var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1878 5.09476C11.6874 4.11604 12.6934 3.50001 13.7923 3.50001C14.8323 3.50001 15.794 4.0524 16.318 4.95073L18.3885 8.5H9.44974L11.1878 5.09476Z",
    stroke: "#404040",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9C4.5 8.72386 4.72386 8.5 5 8.5H23C23.2761 8.5 23.5 8.72386 23.5 9V21C23.5 21.2761 23.2761 21.5 23 21.5H5C4.72386 21.5 4.5 21.2761 4.5 21V9Z",
    stroke: "#404040",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C10.1667 15.8148 11.5578 14.3333 13 14.3333C16 14.3333 16.5 17 19 13",
    stroke: "#404040",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 19,
    width: 6,
    height: 2,
    transform: "rotate(90 15 19)",
    fill: "#F1F0F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    width: 7,
    height: 2,
    transform: "rotate(90 15 0)",
    fill: "#F1F0F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 16.5,
    width: 7,
    height: 2,
    transform: "rotate(180 28 16.5)",
    fill: "#F1F0F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 16.5,
    width: 7,
    height: 2,
    transform: "rotate(180 7 16.5)",
    fill: "#F1F0F0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.94868,
    y1: 22.8974,
    x2: 6.89737,
    y2: 26.0513,
    stroke: "#404040",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: -1.5,
    x2: 4.82456,
    y2: -1.5,
    transform: "matrix(0.316228 0.948683 0.948683 -0.316228 21 21)",
    stroke: "#404040",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/about-icon.e5dace5f.svg";
export { ForwardRef as ReactComponent };